import {
    SIDEBAR_ANCHOR_POSITIONS,
    SIDEBAR_SCROLL_TYPES,
    SIDEBAR_STYLES,
    SIDEBAR_VARIANTS,
    SIDEBAR_VIEWS
} from "@jumbo/utils/constants/layout";

const layoutConfig = {
    sidebar: {
        open: false,
        hide: false,
        variant: SIDEBAR_VARIANTS.PERMANENT,
        style: SIDEBAR_STYLES.FULL_HEIGHT,
        view: SIDEBAR_VIEWS.MINI,
        scrollType: SIDEBAR_SCROLL_TYPES.FIXED,
        anchor: SIDEBAR_ANCHOR_POSITIONS.LEFT,
    },
    header: {
        hide: true,
        fixed: true,
    },
    footer: {
        hide: false,
    },
    root: {
    },
    content: {
        sx: {
            // En el teléfono el margen lateral se achica: con 16px de página más el relleno de las cards,
            // el contenido de gráficos y tablas quedaba sin ancho.
            py: { xs: 1.25, md: 2.5 },
            px: { xs: 1, sm: 2, md: 4, lg: 6 },
        }
    }
};

export default layoutConfig;
